<script>
    import { onMount } from "svelte";
    import { v4 } from "uuid";
    import { setInputFilter } from "../../Utils/utilFunctions.svelte";

    export let value;
    export let inputId;
    export let inputClass = "";
    export let inputPlaceholder = "";
    export let isDisable = false;
    export let inputFunc = () => {};
    export let min;
    export let max;
    export let showInvalid = false;

    const uuid = v4();

    $: id = inputId ?? uuid;

    onMount(() => {
        setInputFilter(
            document.getElementById(id),
            function (value) {
                return value ? /^[0-9-\s]+$/i.test(value) : true;
            },
            "Must be an integer",
        );
    });

    const handlePaste = (e) => {
        const pasteData = e.clipboardData.getData("text");
        const sanitizedData = pasteData.replace(/[^0-9-]/g, "");
        e.preventDefault();

        if (sanitizedData) {
            value = sanitizedData;
            inputFunc();
        }
    };
</script>

<input
    type="number"
    class={`input input-sm input-bordered ${inputClass}`}
    {id}
    disabled={isDisable}
    placeholder={inputPlaceholder}
    on:input={inputFunc}
    on:paste={handlePaste}
    bind:value
    {min}
    {max}
    class:invalid={showInvalid &&
        value &&
        ((min !== undefined && value < min) ||
            (max !== undefined && value > max))}
/>

<style>
    .invalid {
        border: 1px solid rgba(249, 47, 114, 0.5);
        background-color: rgba(249, 47, 114, 0.1);
        border-radius: 5px;
    }
    .invalid:focus {
        border-color: #f92f72;
        box-shadow: 0px 0px 0px 2px rgba(249, 47, 114, 0.5);
    }
</style>
